import { FormControl, Input } from '@chakra-ui/react';
import React from 'react';

import { ConcentrationCalcFieldLabel } from './ConcentrationCalcFieldLabel';

export const PropertyKeyEditor = ({
  value,
  onChange,
}: {
  value: string;
  onChange: (newValue: string) => void;
}) => {
  return (
    <FormControl mb={4}>
      <ConcentrationCalcFieldLabel
        mb={1}
        label="Property Key"
        tooltip="Property Key must be camelCased."
      />

      <Input
        value={value}
        placeholder="Enter property key"
        onChange={(e) => onChange(e.target.value)}
      />
    </FormControl>
  );
};
